// extracted by mini-css-extract-plugin
export var actionButton = "_k0-0";
export var fileInput = "_k0-2";
export var paperclip = "_k0-1";